import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SelectButton } from 'primereact/selectbutton';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const MandateworldEditstep2Page = (props) => {
		const app = useApp();
	const api = useApi();
	// form validation schema
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label("Loanaccountno"),
		loanproductid: yup.string().required().label("Loanproductid"),
		firstcollectiondate: yup.string().required().label("Firstcollectiondate"),
		principalamount: yup.string().required().label("Principalamount"),
		interestrate: yup.number().required().label("Interestrate"),
		processingfee: yup.number().required().label("Processingfee"),
		loanterm: yup.number().required().label("Loanterm"),
		frequency: yup.string().required().label("Frequency"),
		collectionamount: yup.string().required().label("Collectionamount"),
		lastcollectiondate: yup.string().required().label("Lastcollectiondate"),
		isamortgenerated: yup.number().nullable().label("Isamortgenerated"),
		photo: yup.string().nullable().label("Photo"),
		pancard: yup.string().nullable().label("Pancard")
	});
	// form default values
	const formDefaultValues = {
		loanaccountno: '', 
		loanproductid: '', 
		firstcollectiondate: new Date(), 
		principalamount: '', 
		interestrate: '', 
		processingfee: '', 
		loanterm: '', 
		frequency: '', 
		collectionamount: '', 
		lastcollectiondate: new Date(), 
		isamortgenerated: "((0))", 
		photo: '', 
		pancard: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`//mandateworld/editstep3/${this.id}`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
  async function loanproductidAutoFill(e, formik, index) {
        formik.handleChange(e);
        const val = e.target.value;
        const resp = await api.get(`components_data/mandateworld_loanproductid_autofill?value=${val}`);
        const data = resp.data[0];
        if(data){
formik.setFieldValue('interestrate', data.interestrate);
formik.setFieldValue('processingfee', data.processingfee);
formik.setFieldValue('loanterm', data.loanterm);
        }
    };
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="MandateworldEditstep2Page" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Mandateworld"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loanaccountno *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanaccountno"  onChange={formik.handleChange}  value={formik.values.loanaccountno}   label="Loanaccountno" type="text" placeholder="Enter Loanaccountno"     disabled   className={inputClassName(formik?.errors?.loanaccountno)} />
                                                <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loanproductid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanproductid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <SelectButton name="loanproductid" className={inputClassName(formik?.errors?.loanproductid, '')} value={formik.values.loanproductid} onChange={formik.handleChange} options={response} optionLabel="label" optionValue="value" />
                                                    <ErrorMessage name="loanproductid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Firstcollectiondate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="firstcollectiondate" showButtonBar className={inputClassName(formik?.errors?.firstcollectiondate)} dateFormat="yy-mm-dd" value={formik.values.firstcollectiondate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="firstcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Principalamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principalamount"  onChange={formik.handleChange}  value={formik.values.principalamount}   label="Principalamount" type="text" placeholder="Enter Principalamount"        className={inputClassName(formik?.errors?.principalamount)} />
                                                <ErrorMessage name="principalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Interestrate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label="Interestrate" type="number" placeholder="Enter Interestrate"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.interestrate)} />
                                                <ErrorMessage name="interestrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Processingfee *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label="Processingfee" type="number" placeholder="Enter Processingfee"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.processingfee)} />
                                                <ErrorMessage name="processingfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Loanterm *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="loanterm"  onChange={formik.handleChange}  value={formik.values.loanterm}   label="Loanterm" type="number" placeholder="Enter Loanterm"  min={0}  step="any"    className={inputClassName(formik?.errors?.loanterm)} />
                                                <ErrorMessage name="loanterm" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Frequency *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="frequency"  onChange={formik.handleChange}  value={formik.values.frequency}   label="Frequency" type="text" placeholder="Enter Frequency"        className={inputClassName(formik?.errors?.frequency)} />
                                                <datalist id="frequency_list">
                                                { app.menus.frequency2.map((option, index)=> <option key={index} value={option.value}>{option.label}</option>)}
                                                </datalist>
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Collectionamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="collectionamount"  onChange={formik.handleChange}  value={formik.values.collectionamount}   label="Collectionamount" type="text" placeholder="Enter Collectionamount"     disabled   className={inputClassName(formik?.errors?.collectionamount)} />
                                                <ErrorMessage name="collectionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastcollectiondate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="lastcollectiondate"     optionLabel="label" optionValue="value" value={formik.values.lastcollectiondate} onChange={formik.handleChange} options={[]} label="Lastcollectiondate"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.lastcollectiondate)}   />
                                                <ErrorMessage name="lastcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isamortgenerated 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isamortgenerated"  onChange={formik.handleChange}  value={formik.values.isamortgenerated}   label="Isamortgenerated" type="number" placeholder="Enter Isamortgenerated"  min={0}  step="any"    className={inputClassName(formik?.errors?.isamortgenerated)} />
                                                <ErrorMessage name="isamortgenerated" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Photo 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.photo)}>
                                                    <Uploader name="photo" showUploadedFiles value={formik.values.photo} uploadPath="fileuploader/upload/photo" onChange={(paths) => formik.setFieldValue('photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label="Choose files or drop files here" onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="photo" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pancard 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label="Pancard" type="text" placeholder="Enter Pancard"        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update & Next" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
MandateworldEditstep2Page.defaultProps = {
	primaryKey: 'loanaccountno',
	pageName: 'mandateworld',
	apiPath: 'mandateworld/editstep2',
	routeName: 'mandateworldeditstep2',
	submitButtonLabel: "Update & Next",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default MandateworldEditstep2Page;
